import { render } from "./ReceivedParcel.vue?vue&type=template&id=25024286&scoped=true"
import script from "./ReceivedParcel.vue?vue&type=script&lang=js"
export * from "./ReceivedParcel.vue?vue&type=script&lang=js"

import "./ReceivedParcel.vue?vue&type=style&index=0&id=25024286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25024286"]])

export default __exports__